export default "__VITE_ASSET__BhQhyeV0__"